<template>
    <div>
      Loading....
    </div>
</template>

<script>


import _debug from 'debug';
var mdebug = _debug('esma:reload');

export default {
  mixins: [],
    components: {

  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
    var dest = this.$route.params.return_to;
    setTimeout(() => {
      return this.$router.push(dest);
    }, 1);

  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// page_0092_reload.vue?41970e27